import { render } from "./EcommerceGalleryView.vue?vue&type=template&id=7a4cc7cc&scoped=true"
import script from "./EcommerceGalleryView.vue?vue&type=script&lang=js"
export * from "./EcommerceGalleryView.vue?vue&type=script&lang=js"

import "./EcommerceGalleryView.vue?vue&type=style&index=0&id=7a4cc7cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4cc7cc"]])

export default __exports__